// import React from 'react'
//
// const svgProps = {
//   viewBox: '0 0 24 24',
//   fill: 'none',
//   stroke: 'currentColor',
//   strokeWidth: 1.8,
//   strokeLinecap: 'round',
//   strokeLinejoin: 'round'
// }
//
// export const MenuIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M4 6h16M4 12h16M4 18h16" /></svg>
// )
//
// export const SearchIcon = (props) => (
//   <svg {...svgProps} {...props}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
// )
//
// export const BellIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" /><path d="M10 21h4" /></svg>
// )
//
// export const CalendarIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M4 4h16v16H4z" /><path d="M8 2v4M16 2v4M4 9h16" /></svg>
// )
//
// export const PlusIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M12 5v14M5 12h14" /></svg>
// )
//
// export const StatFileIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M8 13h8M8 17h5" /></svg>
// )
//
// export const StatClockIcon = (props) => (
//   <svg {...svgProps} {...props}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
// )
//
// export const StatCheckIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="m4 12 5 5L20 6" /></svg>
// )
//
// export const StatChartIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M4 19V5M4 19h16" /><path d="m7 15 4-4 3 2 5-6" /></svg>
// )
//
// export const MoreDotsIcon = (props) => (
//   <span style={{ fontSize: 18, lineHeight: 1, color: '#84908b' }} {...props}>⋮</span>
// )
//
// export const AddManuscriptIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M12 5v14M5 12h14" /></svg>
// )
//
// export const AssignReviewerIcon = (props) => (
//   <svg {...svgProps} {...props}><circle cx="12" cy="8" r="4" /><path d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" /></svg>
// )
//
// export const CreateIssueIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></svg>
// )
//
// export const ExportReportIcon = (props) => (
//   <svg {...svgProps} {...props}><path d="M4 19V5M4 19h16" /><path d="m7 15 4-4 3 2 5-6" /></svg>
// )


import React from 'react'

const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}

// --- Topbar & Common UI Icons ---
export const MenuIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 6h16M4 12h16M4 18h16" /></svg>
)

export const SearchIcon = (props) => (
  <svg {...svgProps} {...props}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
)

export const BellIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" /><path d="M10 21h4" /></svg>
)

export const CalendarIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 4h16v16H4z" /><path d="M8 2v4M16 2v4M4 9h16" /></svg>
)

export const PlusIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M12 5v14M5 12h14" /></svg>
)

// --- Stat Card Icons ---
export const StatFileIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M8 13h8M8 17h5" /></svg>
)

export const StatClockIcon = (props) => (
  <svg {...svgProps} {...props}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
)

export const StatCheckIcon = (props) => (
  <svg {...svgProps} {...props}><path d="m4 12 5 5L20 6" /></svg>
)

export const StatChartIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 19V5M4 19h16" /><path d="m7 15 4-4 3 2 5-6" /></svg>
)

export const MoreDotsIcon = (props) => (
  <span style={{ fontSize: 18, lineHeight: 1, color: '#84908b' }} {...props}>⋮</span>
)

// --- Quick Actions Icons ---
export const AddManuscriptIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M12 5v14M5 12h14" /></svg>
)

export const AssignReviewerIcon = (props) => (
  <svg {...svgProps} {...props}><circle cx="12" cy="8" r="4" /><path d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" /></svg>
)

export const CreateIssueIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></svg>
)

export const ExportReportIcon = (props) => (
  <svg {...svgProps} {...props}><path d="M4 19V5M4 19h16" /><path d="m7 15 4-4 3 2 5-6" /></svg>
)

// --- Sidebar Menu Icons (Prototype SVGs) ---
export const DashboardNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <rect x="3" y="3" width="7" height="7" rx="2" />
    <rect x="14" y="3" width="7" height="7" rx="2" />
    <rect x="3" y="14" width="7" height="7" rx="2" />
    <rect x="14" y="14" width="7" height="7" rx="2" />
  </svg>
)

export const SearchArticleNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
    <path d="M8 11h6M11 8v6" />
  </svg>
)

export const ArticleNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M8 13h8M8 17h6" />
  </svg>
)

export const AbstractNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <path d="M4 4h16v16H4z" />
    <path d="M8 8h8M8 12h8M8 16h5" />
  </svg>
)

export const JournalNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
)

export const UserNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
)

export const TemplateNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <path d="M4 4h16v16H4z" />
    <path d="M8 3v18M3 9h18" />
  </svg>
)

export const BlogNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <path d="M4 5h16v14H4z" />
    <path d="M8 9h8M8 13h5" />
    <path d="m16 16 2 2 3-4" />
  </svg>
)

export const EventNavIcon = (props) => (
  <svg {...svgProps} {...props}>
    <path d="M3 4h18v17H3z" />
    <path d="M8 2v4M16 2v4M3 9h18" />
    <path d="M8 13h3M8 17h7" />
  </svg>
)

// Export Aliases
export const ManageTemplatesNavIcon = TemplateNavIcon
export const BlogsNavIcon = BlogNavIcon

// --- Helper: Maps Menu Key / Path / Name -> Prototype SVG Icon ---
export const getSidebarNavIcon = (lookupKey, item) => {
  if (!lookupKey && !item) return null

  const str = String(
    (item && (item.key || item.path || item.name || item.icon)) || lookupKey || ''
  ).toLowerCase()

  if (str.includes('dashboard')) return <DashboardNavIcon />
  if (str.includes('search')) return <SearchArticleNavIcon />
  if (
    str.includes('article') ||
    str.includes('submission') ||
    str.includes('manuscript') ||
    str.includes('pending')
  ) {
    return <ArticleNavIcon />
  }

  if (str.includes('abstract')) return <AbstractNavIcon />
  if (
    str.includes('journal') ||
    str.includes('subscription') ||
    str.includes('subscriber') ||
    str.includes('payment')
  ) {
    return <JournalNavIcon />
  }

  if (
    str.includes('user') ||
    str.includes('member') ||
    str.includes('activity') ||
    str.includes('password') ||
    str.includes('reviewer') ||
    str.includes('author') ||
    str.includes('institute') ||
    str.includes('admin')
  ) {
    return <UserNavIcon />
  }

  if (str.includes('template') || str.includes('keyword')) return <TemplateNavIcon />
  if (
    str.includes('blog') ||
    str.includes('news') ||
    str.includes('testimonial') ||
    str.includes('feedback')
  ) {
    return <BlogNavIcon />
  }

  if (str.includes('event') || str.includes('conference')) return <EventNavIcon />

  return <ArticleNavIcon />
}